import React, { useContext, useEffect, useState } from "react";
import axios from "../../../../axios";
import ChannelRequest from "./ChannelRequest";
import { useSelector } from "react-redux";
import RequestContext from "../../../Open_community/Create_channel/View_Channel_Screen/View_First_Screen/requestContext";

function SingleChannelRequest({
  communityId,
  setPostRequestCount,
  setRejectedPostCount,
  setRequestedpostsCount,
  requestedPostCount
}) {
  const [requestList, setRequestList] = useState([]);
  const [postStatusChanged, setPostStatusChanged] = useState(false);
  const [inProgress, setInProgress] = useState(true);
  const currentUser = useSelector((state) => state.user.currentUser)


  const [filter, setFilter] = useState({
    limit: 2,
    page: 1,
    sortBy: -1,
  });

  const { limit, page, sortBy } = filter;

  const handelInfiniteScroll = async () => {
    try {
      if (
        document.getElementById("single-channel-request-scroll").clientHeight +
        document.getElementById("single-channel-request-scroll").scrollTop +
        1 >=
        document.getElementById("single-channel-request-scroll").scrollHeight
      ) {
        setFilter((prevState) => ({ ...prevState, page: prevState.page + 1 }));
      }
    } catch (error) {
      console.log(error);
    }
  };
  // const {setRequestedpostsCount} = useContext(RequestContext)


  useEffect(() => {
    const element = document.getElementById("single-channel-request-scroll");
    if (element) {
      element.addEventListener("scroll", handelInfiniteScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener("scroll", handelInfiniteScroll);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPostRequest = async () => {
    try {
      const postRequest = await axios.get(
        `/community/${communityId}/post/getUserPosts/${currentUser?.id}`
      );
      if (postRequest) {
        const NotactiveEntries = postRequest.data.data.filter(entry => entry.status !== 'active' && entry.isDeleted !== true);
        setRequestList((prev) => [...prev, ...NotactiveEntries]);
        setInProgress(false);
        setRequestedpostsCount(NotactiveEntries.length)
      }
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    // setInProgress(true);
    getPostRequest();
  }, [postStatusChanged, limit]);
  // postStatusChanged;
  return (
    <div className="w-full">
      {inProgress ? (
        <div className="loader_container">
          <img
            className="request_post_loader"
            src="/gif/LoaderDot.gif"
            alt=""
          />
        </div>
      ) : requestList && requestList?.length > 0 ? (
        requestList.map((requestPost) => (
          <ChannelRequest
            setPostRequestCount={setPostRequestCount}
            requestPost={requestPost}
            setFilter={setFilter}
            filter={filter}
            setInProgress={setInProgress}
            setPostStatusChanged={setPostStatusChanged}
            setRejectedPostCount={setRejectedPostCount}
            postStatusChanged={postStatusChanged}
            setRequestList={setRequestList}
            getPostRequest={getPostRequest}
          />
        ))
      ) : (
        <span>No posts yet.</span>
      )}
    </div>
  );
}

export default SingleChannelRequest;
